import axios from "axios";
import { firebase } from "../firebase/firebase-config";

export const getToken = async () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        user
          .getIdToken()
          .then(function(idToken) {
            resolve(idToken);
          })
          .catch(() => reject());
      } else {
        reject();
      }
    });
  });
};

const API = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/vnd.radarapi.v1+json"
  }
});

// API.interceptors.request.use(async function(config) {
//   const user = firebase.auth().currentUser;
//   if (user) {
//     const token = await getToken();
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//   }
//   return config;
// });

export default API;
